<template>
  
  <div id="app" >
    <clickerHeader></clickerHeader>
    <router-view />
    <clickerFooter></clickerFooter>
  </div>
  
</template>

<script>
import clickerHeader from './components/clickerheader.vue'
import clickerFooter from './components/clickerfooter.vue'

export default {
  name: 'app',
  components: {
    clickerHeader,
    clickerFooter
  },
  
  data: function() {
    return { };
  },
  
  watch: {
    '$route': async function() {
      if(this.$route.query) {
        if(this.$route.query.lng) {
          let validLanguages = ['it', 'en'];
          let language = this.$route.query.lng;
          this.$i18n.locale= (validLanguages.includes(language)) ? language : 'en';
        }
      }
    }
  },
  
  mounted: async function() {
    const queryString = window.location.search;
    console.log('queryString', queryString);
    const urlParams = new URLSearchParams(queryString);
    // for (const [key, value] of urlParams) { console.log(`The value for key ${key} is ${value}`); }
    
    if(urlParams.has('lng')) {
      let validLanguages = ['it', 'en'];
      let language = urlParams.get('lng');
      this.$i18n.locale= (validLanguages.includes(language)) ? language : 'en';
    }
    
    if(urlParams.has('type')) {
      let type = urlParams.get('type');
      
      if(type == 'survey' && urlParams.has('sid')) {
        let sid = urlParams.get('sid');        
        let params = { recordid: sid };
        this.$router.push({ name: 'survey', params: params });
      }
      
      if(type == 'typage') {
        let params = (urlParams.has('fs')) ? { fromSurvey: true } : { };
        this.$router.push({ name: 'typage', params: params  });   
      }
    }
  },
  
  methods: {
    
  },
}
</script>

<style>

#hs_cos_wrapper_widget_1715850937749 {
  display: block !important;
  padding-bottom: 40px !important;
  padding-top: 40px !important
}

#hs_cos_wrapper_widget_1715850937749 {
  display: block !important;
  padding-bottom: 40px !important;
  padding-top: 40px !important
}

.dnd_area-row-0-max-width-section-centering>.row-fluid {
  max-width: 900px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.dnd_area-row-5-max-width-section-centering>.row-fluid {
  max-width: 1000px !important;
  margin-left: auto !important;
  margin-right: auto !important;
}

.dnd_area-row-8-force-full-width-section>.row-fluid {
  max-width: none !important;
}

.module_17152579202108-flexbox-positioning {
  display: -ms-flexbox !important;
  -ms-flex-direction: column !important;
  -ms-flex-align: center !important;
  -ms-flex-pack: start;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: flex-start;
}

.module_17152579202108-flexbox-positioning>div {
  max-width: 100%;
  flex-shrink: 0 !important;
}

.dnd_area-dnd_partial-2-module-2-flexbox-positioning {
  display: -ms-flexbox !important;
  -ms-flex-direction: column !important;
  -ms-flex-align: center !important;
  -ms-flex-pack: start;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: flex-start;
}

.dnd_area-dnd_partial-2-module-2-flexbox-positioning>div {
  max-width: 100%;
  flex-shrink: 0 !important;
}

/* HubSpot Non-stacked Media Query Styles */
@media (min-width:768px) {
  .dnd_area-row-1-vertical-alignment>.row-fluid {
    display: -ms-flexbox !important;
    -ms-flex-direction: row;
    display: flex !important;
    flex-direction: row;
  }
  
  .dnd_area-row-3-vertical-alignment>.row-fluid {
    display: -ms-flexbox !important;
    -ms-flex-direction: row;
    display: flex !important;
    flex-direction: row;
  }
  
  .dnd_area-dnd_partial-3-column-1-vertical-alignment {
    display: -ms-flexbox !important;
    -ms-flex-direction: column !important;
    -ms-flex-pack: center !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
  
  .dnd_area-dnd_partial-3-column-1-vertical-alignment>div {
    flex-shrink: 0 !important;
  }
  
  .cell_17152587627382-vertical-alignment {
    display: -ms-flexbox !important;
    -ms-flex-direction: column !important;
    -ms-flex-pack: center !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
  
  .cell_17152587627382-vertical-alignment>div {
    flex-shrink: 0 !important;
  }
  
  .cell_17152587627382-row-0-vertical-alignment>.row-fluid {
    display: -ms-flexbox !important;
    -ms-flex-direction: row;
    display: flex !important;
    flex-direction: row;
  }
  
  .dnd_area-dnd_partial-2-module-1-vertical-alignment {
    display: -ms-flexbox !important;
    -ms-flex-direction: column !important;
    -ms-flex-pack: center !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
  
  .dnd_area-dnd_partial-2-module-1-vertical-alignment>div {
    flex-shrink: 0 !important;
  }
  
  .cell_1715258762736-vertical-alignment {
    display: -ms-flexbox !important;
    -ms-flex-direction: column !important;
    -ms-flex-pack: center !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
  
  .cell_1715258762736-vertical-alignment>div {
    flex-shrink: 0 !important;
  }
  
  .cell_1715258762736-row-0-vertical-alignment>.row-fluid {
    display: -ms-flexbox !important;
    -ms-flex-direction: row;
    display: flex !important;
    flex-direction: row;
  }
  
  .dnd_area-dnd_partial-2-module-2-vertical-alignment {
    display: -ms-flexbox !important;
    -ms-flex-direction: column !important;
    -ms-flex-pack: center !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
  
  .dnd_area-dnd_partial-2-module-2-vertical-alignment>div {
    flex-shrink: 0 !important;
  }
  
  .cell_1739286680707-row-0-vertical-alignment>.row-fluid {
    display: -ms-flexbox !important;
    -ms-flex-direction: row;
    display: flex !important;
    flex-direction: row;
  }
  
  .module_17392866807073-vertical-alignment {
    display: -ms-flexbox !important;
    -ms-flex-direction: column !important;
    -ms-flex-pack: center !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
  
  .module_17392866807073-vertical-alignment>div {
    flex-shrink: 0 !important;
  }
  
  .cell_1739286676881-row-0-vertical-alignment>.row-fluid {
    display: -ms-flexbox !important;
    -ms-flex-direction: row;
    display: flex !important;
    flex-direction: row;
  }
  
  .module_17392866768822-vertical-alignment {
    display: -ms-flexbox !important;
    -ms-flex-direction: column !important;
    -ms-flex-pack: center !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
  
  .module_17392866768822-vertical-alignment>div {
    flex-shrink: 0 !important;
  }
  
  .cell_17152668791253-row-0-vertical-alignment>.row-fluid {
    display: -ms-flexbox !important;
    -ms-flex-direction: row;
    display: flex !important;
    flex-direction: row;
  }
  
  .module_17152668791256-vertical-alignment {
    display: -ms-flexbox !important;
    -ms-flex-direction: column !important;
    -ms-flex-pack: center !important;
    display: flex !important;
    flex-direction: column !important;
    justify-content: center !important;
  }
  
  .module_17152668791256-vertical-alignment>div {
    flex-shrink: 0 !important;
  }
}

/* HubSpot Styles (default) */
.dnd_area-row-0-padding {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.dnd_area-row-0-background-layers {
  background-image: url('https://www.gnet.it/hubfs/Marketing%20Division%20%2814%29.png') !important;
  background-position: center center !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
}

.dnd_area-row-1-padding {
  padding-bottom: 0px !important;
}

.dnd_area-row-1-background-layers {
  background-image: linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 1)) !important;
  background-position: left top !important;
  background-size: auto !important;
  background-repeat: no-repeat !important;
}

.dnd_area-row-2-padding {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.dnd_area-row-3-padding {
  padding-top: 60px !important;
  padding-bottom: 60px !important;
}

.dnd_area-row-3-background-layers {
  background-image: linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 1)) !important;
  background-position: left top !important;
  background-size: auto !important;
  background-repeat: no-repeat !important;
}

.dnd_area-row-4-padding {
  padding-top: 30px !important;
  padding-bottom: 0px !important;
}

.dnd_area-row-4-background-layers {
  background-image: linear-gradient(rgba(207, 226, 243, 0.4), rgba(207, 226, 243, 0.4)) !important;
  background-position: left top !important;
  background-size: auto !important;
  background-repeat: no-repeat !important;
}

.dnd_area-row-5-padding {
  padding-top: 40px !important;
  padding-bottom: 0px !important;
}

.dnd_area-row-5-background-layers {
  background-image: linear-gradient(rgba(207, 226, 243, 0.3), rgba(207, 226, 243, 0.3)) !important;
  background-position: left top !important;
  background-size: auto !important;
  background-repeat: no-repeat !important;
}

.dnd_area-row-6-hidden {
  display: none !important;
}

.dnd_area-row-7-hidden {
  display: none !important;
}

.dnd_area-row-8-padding {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.dnd_area-row-8-hidden {
  display: none !important;
}

.dnd_area-row-9-hidden {
  display: none !important;
}

.cell_17159328100492-padding {
  padding-top: 0px !important;
  padding-bottom: 8px !important;
}

.dnd_area-dnd_partial-3-column-1-padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.dnd_area-dnd_partial-3-column-1-row-0-padding {
  padding-bottom: 20px !important;
}

.dnd_area-dnd_partial-3-column-1-row-1-padding {
  padding-bottom: 48px !important;
}

.dnd_area-dnd_partial-3-module-3-hidden {
  display: block !important;
}

.cell_17152579202105-padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.cell_17152579202105-row-0-padding {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.widget_1715850937749-hidden {
  display: none !important;
}

.module_1715850923799-hidden {
  display: none !important;
}

.dnd_area-dnd_partial-2-module-1-hidden {
  display: flex !important;
}

.cell_1739286680707-padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.cell_1739286680707-row-0-padding {
  padding-bottom: 80px !important;
}

.cell_1739286676881-padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.cell_1739286676881-row-0-padding {
  padding-bottom: 80px !important;
}

.cell_17152668791253-padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.cell_17152668791253-row-0-padding {
  padding-bottom: 80px !important;
}

.dnd_area-dnd_partial-9-column-1-padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.dnd_area-dnd_partial-9-column-1-row-0-padding {
  padding-bottom: 48px !important;
}

.dnd_area-dnd_partial-4-column-1-padding {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.dnd_area-dnd_partial-4-column-1-row-0-padding {
  padding-bottom: 48px !important;
}

.dnd_area_footer-row-0-padding {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.dnd_area_footer-row-0-background-layers {
  background-image: linear-gradient(rgba(66, 91, 118, 1), rgba(66, 91, 118, 1)) !important;
  background-position: left top !important;
  background-size: auto !important;
  background-repeat: no-repeat !important;
}



</style>
